export default [
    {
      path: '/nSActivity/:activityCodes',
      meta:{
        title: '开业活动'
      },
      component: (resolve) => require(['@/pages/newStoreActivity/index'], resolve)
    }
  ]